export const categories = [
  {
    id: 1,
    namePl: "Buty",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    imageQuery: "Stylish%20sneakers%20on%20a%20minimal%20white%20background%2C%20trendy%20footwear%20photography%20with%20soft%20natural%20lighting%2C%20clean%20product%20shot%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20tones%2C%20high%20detail%20texture%2C%20professional%20ecommerce%20photography",
  },
  {
    id: 2,
    namePl: "Bluzy / Swetry",
    nameEn: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageSeq: "cat-hoodies-02",
    imageQuery: "Cozy%20oversized%20hoodie%20on%20clean%20cream%20background%2C%20minimal%20streetwear%20photography%20with%20soft%20diffused%20lighting%2C%20neutral%20earth%20tones%2C%20textile%20texture%20visible%2C%20modern%20fashion%20editorial%20style%2C%20professional%20product%20photography",
  },
  {
    id: 3,
    namePl: "T-Shirty",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageSeq: "cat-tshirts-03",
    imageQuery: "Premium%20cotton%20t-shirt%20flat%20lay%20on%20light%20beige%20surface%2C%20minimalist%20product%20photography%20with%20gentle%20shadows%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20high%20quality%20fabric%20details%20visible",
  },
  {
    id: 4,
    namePl: "Kurtki",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageSeq: "cat-jackets-04",
    imageQuery: "Stylish%20bomber%20jacket%20displayed%20on%20minimal%20wooden%20hanger%20against%20soft%20cream%20wall%2C%20modern%20fashion%20photography%20with%20warm%20ambient%20lighting%2C%20earth%20tone%20color%20palette%2C%20textile%20texture%20emphasis%2C%20editorial%20quality",
  },
  {
    id: 5,
    namePl: "Spodnie / Szorty",
    nameEn: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageSeq: "cat-pants-05",
    imageQuery: "Casual%20trousers%20neatly%20folded%20on%20light%20linen%20fabric%20background%2C%20minimalist%20product%20photography%20with%20soft%20warm%20lighting%2C%20clean%20composition%2C%20neutral%20beige%20and%20cream%20tones%2C%20textile%20texture%20visible%2C%20professional%20ecommerce%20style",
  },
  {
    id: 6,
    namePl: "Nakrycia Głowy",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageSeq: "cat-headwear-06",
    imageQuery: "Trendy%20baseball%20cap%20on%20minimal%20white%20pedestal%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20background%2C%20modern%20streetwear%20aesthetic%2C%20high%20detail%20embroidery%20visible%2C%20editorial%20quality",
  },
  {
    id: 7,
    namePl: "Zestawy",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageSeq: "cat-sets-07",
    imageQuery: "Matching%20two-piece%20outfit%20set%20displayed%20on%20minimal%20cream%20background%2C%20coordinated%20fashion%20photography%20with%20soft%20diffused%20lighting%2C%20warm%20earth%20tones%2C%20clean%20aesthetic%20composition%2C%20professional%20product%20photography",
  },
  {
    id: 8,
    namePl: "Bielizna",
    nameEn: "Underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageSeq: "cat-underwear-08",
    imageQuery: "Premium%20cotton%20underwear%20neatly%20arranged%20on%20soft%20beige%20linen%2C%20minimalist%20product%20photography%20with%20gentle%20natural%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20subtle%20texture%20details%2C%20professional%20style",
  },
  {
    id: 9,
    namePl: "Koszulki Sportowe",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageSeq: "cat-jersey-09",
    imageQuery: "Sports%20jersey%20flat%20lay%20on%20clean%20white%20surface%2C%20athletic%20apparel%20photography%20with%20soft%20studio%20lighting%2C%20minimal%20aesthetic%2C%20warm%20neutral%20background%2C%20fabric%20texture%20details%2C%20professional%20product%20photography",
  },
  {
    id: 10,
    namePl: "Akcesoria",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageSeq: "cat-accessories-10",
    imageQuery: "Various%20fashion%20accessories%20artfully%20arranged%20on%20minimal%20cream%20surface%2C%20lifestyle%20product%20photography%20with%20soft%20warm%20lighting%2C%20clean%20aesthetic%2C%20neutral%20earth%20tones%2C%20editorial%20quality%2C%20harmonious%20composition",
  },
  {
    id: 11,
    namePl: "Torby",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageSeq: "cat-bags-11",
    imageQuery: "Elegant%20leather%20bag%20on%20minimal%20white%20pedestal%2C%20luxury%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20beige%20background%2C%20clean%20composition%2C%20leather%20texture%20visible%2C%20professional%20editorial%20style",
  },
  {
    id: 12,
    namePl: "Paski",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageSeq: "cat-belts-12",
    imageQuery: "Premium%20leather%20belt%20coiled%20on%20minimal%20cream%20surface%2C%20clean%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20buckle%20detail%20visible%2C%20professional%20ecommerce%20style%2C%20leather%20texture%20emphasis",
  },
  {
    id: 13,
    namePl: "Perfumy",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageSeq: "cat-perfumes-13",
    imageQuery: "Elegant%20perfume%20bottle%20on%20minimal%20white%20marble%20surface%2C%20luxury%20product%20photography%20with%20soft%20warm%20lighting%2C%20clean%20aesthetic%2C%20neutral%20cream%20background%2C%20glass%20reflections%2C%20editorial%20quality%2C%20sophisticated%20composition",
  },
  {
    id: 14,
    namePl: "Inne Produkty",
    nameEn: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageSeq: "cat-other-14",
    imageQuery: "Assorted%20lifestyle%20products%20artfully%20arranged%20on%20minimal%20cream%20background%2C%20flat%20lay%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic%20composition%2C%20editorial%20quality",
  },
];

export const quickLinks = [
  { label: "Kakobuy Spreadsheet", url: "https://kaspreadsheet.com", primary: true },
  { label: "Buy It Now", url: "https://kaspreadsheet.com", primary: false },
];